import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Pricing from "@/pages/Pricing";
import Splash from "@/components/Splash";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Comparison from "@/pages/Comparison";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Houses from "@/pages/Houses";
import Timeline from "@/pages/Timeline";
import DataQuality from "@/pages/DataQuality";
import Admin from "@/pages/Admin";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D14]">
        <div className="w-10 h-10 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/compare" element={<Protected><Comparison /></Protected>} />
      <Route path="/artists" element={<Protected><Artists /></Protected>} />
      <Route path="/artists/:cid" element={<Protected><ArtistDetail /></Protected>} />
      <Route path="/houses" element={<Protected><Houses /></Protected>} />
      <Route path="/timeline" element={<Protected><Timeline /></Protected>} />
      <Route path="/quality" element={<Protected roles={["admin", "reviewer"]}><DataQuality /></Protected>} />
      <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <Splash />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
